export const showErrorMsg = function(msg){
    if(msg){
        console.log('msg.commom.js | msg : true =>', msg)
        this.$el.addClass('error')
        this.$el.removeClass('success')
        let selector;
        if(this.$el.closest('.form-row').length > 0){
            if(!this.$el.closest('.form-row').find('.form-util')[0]){
                this.$el.closest('.form-row').append(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-row').find('.form-util').addClass('error');
            this.$el.closest('.form-row').find('.form-util').removeClass('success');
            selector = this.$el.closest('.form-row').find('.form-util');
            msgAddTxt(msg, selector);

        }else if(this.$el.closest('.form-col-group')[0]){
            if (!this.$el.closest('.form-col-group').next('.form-util')[0]) {
                this.$el.closest('.form-col-group').after(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-col-group').next('.form-util').addClass('error');
            this.$el.closest('.form-col-group').next('.form-util').removeClass('success');
            selector = this.$el.closest('.form-col-group').next('.form-util');
            msgAddTxt(msg, selector);
        }else{
            if(!this.$el.next('.form-util')[0]){
                this.$el.after(`<div class="form-util"></div>`);
            }
            this.$el.next('.form-util').addClass('error');
            this.$el.next('.form-util').removeClass('success');
            selector = this.$el.next('.form-util');
            msgAddTxt(msg, selector);
        }
    }else{
        console.log('msg.commom.js | msg : false =>', msg)
        this.$el.removeClass('error')

        if(this.$el.closest('.form-row').length > 0){
            this.$el.closest('.form-row').find('.form-util').removeClass('error');
        }else if(this.$el.closest('.form-col-group')[0]){
            this.$el.closest('.form-col-group').next('.form-util').removeClass('error');
        }else{
            this.$el.next('.form-util').removeClass('error');
        }
    }
}

export const showInfoMsg = function(msg, right){ // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가
    if(msg){
        this.$el.removeClass('error success')
        let selector;
        if(this.$el.closest('.form-row').length > 0){
            if(!this.$el.closest('.form-row').find('.form-util')[0]){
                this.$el.closest('.form-row').append(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-row').find('.form-util').removeClass('error success');
            selector = this.$el.closest('.form-row').find('.form-util');
            msgAddTxt(msg, selector, 'info', right); // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가

        }else if(this.$el.closest('.form-col-group')[0]){
            if(!this.$el.closest('.form-group').find('.form-col-group').next('.form-util')[0]){
                this.$el.closest('.form-group').find('.form-col-group').after(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-group').find('.form-col-group').next('.form-util').removeClass('error success');
            selector = this.$el.closest('.form-group').find('.form-util')
            msgAddTxt(msg, selector, 'info', right); // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가
        }else{
            if(!this.$el.next('.form-util')[0]){
                this.$el.after(`<div class="form-util"></div>`);
            }
            this.$el.next('.form-util').removeClass('error success');
            selector = this.$el.next('.form-util')
            msgAddTxt(msg, selector, 'info', right); // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가
        }
    }else{
        this.$el.next('.form-util').find('.helper-msg').remove();
    }
}
export const showSuccessMsg = function(msg){ // FETASK-1751 sussecc 케이스 추가
    if(msg){
        this.$el.removeClass('error')
        this.$el.addClass('success')
        let selector;
        if(this.$el.closest('.form-row').length > 0){
            if(!this.$el.closest('.form-row').find('.form-util')[0]){
                this.$el.closest('.form-row').append(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-row').find('.form-util').removeClass('error');
            this.$el.closest('.form-row').find('.form-util').addClass('success');
            selector = this.$el.closest('.form-row').find('.form-util');
            msgAddTxt(msg, selector, 'success'); 

        }else if(this.$el.closest('.form-col-group')[0]){
            if(!this.$el.closest('.form-group').find('.form-col-group').next('.form-util')[0]){
                this.$el.closest('.form-group').find('.form-col-group').after(`<div class="form-util"></div>`);
            }
            this.$el.closest('.form-group').find('.form-col-group').next('.form-util').removeClass('error');
            this.$el.closest('.form-group').find('.form-col-group').next('.form-util').addClass('success');
            
            selector = this.$el.closest('.form-group').find('.form-util')
            msgAddTxt(msg, selector, 'success');
        }else{
            if(!this.$el.next('.form-util')[0]){
                this.$el.after(`<div class="form-util"></div>`);
            }
            this.$el.next('.form-util').removeClass('error');
            this.$el.next('.form-util').addClass('success');
            selector = this.$el.next('.form-util')
            msgAddTxt(msg, selector, 'success');
        }
    }else{
        this.$el.next('.form-util').find('.helper-msg').remove();
    }
}

const msgAddTxt = function (msg, _this, t, _right){ // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가 : _right
    console.log(3,_right)
    let msgArr = [];
    typeof(msg) == 'string' ? msgArr.push(msg) : msgArr = msg;

    const msgLen = msgArr.length;
    const _type = t == undefined ? 'error' : t;
    // FETASK-1751 sussecc 케이스 추가
    let _msgHtml = ''
    let _msgSelector = ''
    
    /* s: FETASK-접근성-v4.0 : 최종심사 대응 - PBK-APP-FNL2-8 2024-06-11*/
    switch (_type) {        
        case 'error':
            console.log('erorr')
            _msgHtml = '<div class="valid-msg error" aria-live="polite"></div>';
            _msgSelector = '.valid-msg.error';
            break;
        case 'info' :
            console.log('info')
            _msgHtml =  `<div class="helper-msg ${_right == true ? 'right' : ''}"></div>`
            _msgSelector = '.helper-msg';
            break;
        case 'success' :
            console.log('success')
            _msgHtml =  '<div class="valid-msg success" aria-live="polite"></div>'
            _msgSelector = '.valid-msg.success';
        default:
            break;
        
    }
    /* e: FETASK-접근성-v4.0 : 최종심사 대응 - PBK-APP-FNL2-8 2024-06-11*/

    //const _msgSelector = _type == 'error' ?  '.valid-msg' : '.helper-msg';
    _this.find(_msgSelector).length > 0 ? _this.find(_msgSelector).remove() : '';
    for (var i = 0; i < msgLen; i++) { // add info list
        _this.prepend(_msgHtml);
    }
    for (var i = 0; i < msgLen; i++) { // add info text
        _this.find(_msgSelector).eq(i).html(msgArr[i])
    }
}